interface AdditionalData {
  [key: string]: any;
}

export class Option {
  constructor(private readonly id: number | string, private readonly value: string, private readonly additionalData?: AdditionalData | null) { }

  getKey(): number | string {
    return this.id;
  }

  getValue(): string {
    return this.value;
  }

  getAdditionalData(): AdditionalData {
    return this.additionalData!;
  }

  isPremium(): boolean {
    return !!this.additionalData?.['isPremium'];
  }
}
